module.exports = {
  container: 'gathering/details/container',
  name: 'gathering/details/name',
  status: 'gathering/details/status'
}
